import { useQuery } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { shortlistQueryKeys } from '@/modules/public-shortlist/queries/queryKeys';

export const usePublicJobQuery = (code: string) => {
  return useQuery({
    queryKey: shortlistQueryKeys.publicJob(code),
    queryFn: async () => {
      const { data } = await fetchClient.GET('/public/jobs/{code}', {
        params: { path: { code } },
      });

      return data;
    },
    enabled: Boolean(code),
  });
};
